<template>
  <div
    class="quick-rename-input"
    v-text="value"
    :title="title"
    :contenteditable="!disabled"
    :class="{'invalid': isInvalid}"
    :style="{padding: paddingValue}"
    @paste="handlePaste"
    @blur="onBlur($event)"
    @input="maxLength ? checkLength($event) : undefined"
    @keydown.stop.enter="$event.target.blur()"
    @keydown.stop.esc="restoreValue($event, value)"
  ></div>
</template>

<script>
import copyPasteHelpers from '@/helpers/copyPasteHelpers'

export default {
  name: 'QuickRenameInput',
  props: {
    value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Click to edit'
    },
    disabled: {
      type: Boolean,
      required: false
    },
    density: {
      type: String,
      required: false,
      default: 'default'
    },
    maxLength: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      isInvalid: false
    }
  },
  computed: {
    paddingValue () {
      if (!isNaN(this.density)) {
        return `${this.density}px`
      }
      return this.density === 'compact' ? '2px' : '4px'
    }
  },
  methods: {
    onBlur (event) {
      event.target.scroll(0, 0)
      this.isInvalid = false
      this.$emit('onChange', event)
    },
    handlePaste (event) {
      copyPasteHelpers.customPasteHandler(event)
    },
    restoreValue (event) {
      if (!this.disabled) {
        event.target.textContent = this.name
        event.target._ignoreBlur = true
        event.target.blur()
      }
    },
    checkLength (event) {
      this.isInvalid = event.target.innerText.length > this.maxLength
    }
  }
}
</script>

<style scoped>

.quick-rename-input {
  padding: 4px;
  overflow: hidden;
  line-height: 19px;
  border-radius: 4px;
  white-space: nowrap;
  scrollbar-width: none;
  text-overflow: ellipsis;
  -ms-overflow-style: none;
  border: 1px solid transparent;

  &::-webkit-scrollbar {
    display: none;
  }

  &.invalid{
    &[contenteditable="true"]:focus {
      outline: 2px solid red !important;
    }
  }

  &[contenteditable="true"]{
    cursor: text;
  }

  &[contenteditable="true"]:hover {
    background-color: #f0f0f0;
    border: 1px solid #747775;
  }

  &[contenteditable="true"]:focus {
    overflow: auto;
    text-overflow: initial;
    border-color: transparent;
    outline: 2px solid rgba(0, 103, 344)!important;
  }
}
</style>
